module.exports = __webpack_public_path__ + "img/UTANTE-3.1c4d749b.jpg";